import { supportedLanguages, useTranslation, type SupportedLanguage } from "@roastery/i18n";
import { Button } from "@roastery/ui";

/**
 * PL/EN switch for the operator's panel. Like the portal's, it persists the choice only in this
 * browser: an operator has no `tenant_user` row, and `PATCH /api/v1/me` — which is what writes the
 * language back to Keycloak — needs one.
 */
export function LanguageSwitcher() {
  const { i18n, t } = useTranslation();
  const current = i18n.resolvedLanguage;

  return (
    <div
      className="flex items-center gap-1 rounded-md border border-border p-0.5"
      role="group"
      aria-label={t("header.language")}
      data-testid="language-switcher"
    >
      {supportedLanguages.map((language: SupportedLanguage) => (
        <Button
          key={language}
          size="sm"
          variant={current === language ? "secondary" : "ghost"}
          className="h-7 px-2 text-xs uppercase"
          aria-pressed={current === language}
          data-testid={`language-${language}`}
          onClick={() => void i18n.changeLanguage(language)}
        >
          {language}
        </Button>
      ))}
    </div>
  );
}
